import { api } from 'services/api';

export class ContigoService {
  async listContigoStock(data) {
    return api.get('xpcell/contigo-stock', { params: data });
  }

  async listComponentSellPrice(data) {
    return api.get('xpcell/stock/sell-price', { params: data });
  }

  async createOrder(data) {
    return api.post('/contigo/orders', data);
  }

  async listOrders(params) {
    return api.get('/contigo/orders', { params });
  }

  async getOrderById(orderId) {
    return api.get(`/contigo/orders/${orderId}`);
  }

  async updateOrder(orderId, data) {
    return api.put(`/contigo/orders/${orderId}`, data);
  }

  async deleteOrder(orderId) {
    return api.delete(`/contigo/orders/${orderId}`);
  }

  async updateOrderStatus(orderId, status) {
    return api.put(`/contigo/orders/${orderId}/status`, { status });
  }

  // COMMENTS (Comentários)
  async addComment(orderId, comment) {
    return api.post(`/contigo/orders/${orderId}/comments`, { comment });
  }

  // FULFILLMENT (Atendimento)
  async fulfillOrderItem(orderId, itemId, deliveries) {
    return api.post(`/contigo/orders/items/${itemId}/fulfill`, { order_id: orderId, deliveries });
  }

  async createFulfillment(orderId, data) {
    return api.post(`/contigo/orders/${orderId}/fulfillment`, data);
  }

  async listOrderFulfillments(orderId) {
    return api.get(`/contigo/orders/${orderId}/fulfillments`);
  }

  async updateFulfillment(fulfillmentId, data) {
    return api.put(`/contigo/fulfillments/${fulfillmentId}`, data);
  }

  async deleteFulfillment(fulfillmentId) {
    return api.delete(`/contigo/fulfillments/${fulfillmentId}`);
  }

  async returnFulfillment(fulfillmentId, orderId) {
    return api.post('/contigo/fulfillments/return', {
      fulfillment_id: fulfillmentId,
      order_id: orderId,
    });
  }

  // INVOICING (Faturamento)
  async createInvoice(orderId, data) {
    return api.post(`/contigo/orders/${orderId}/invoice`, data);
  }

  async listOrderInvoices(orderId) {
    return api.get(`/contigo/orders/${orderId}/invoices`);
  }

  async getInvoiceById(invoiceId) {
    return api.get(`/contigo/invoices/${invoiceId}`);
  }

  async cancelInvoice(invoiceId) {
    return api.delete(`/contigo/invoices/${invoiceId}`);
  }

  async searchEntryInvoices(partNumber) {
    return api.get('/contigo/entry-invoices', { params: { partNumber } });
  }

  async getEntryInvoiceItems(invoiceId) {
    return api.get(`/contigo/entry-invoices/${invoiceId}/items`);
  }

  async getOrdersAvailableForInvoicing() {
    return api.get('/contigo/orders/available-for-invoicing');
  }

  async createInvoice(data) {
    return api.post('/contigo/invoices', data);
  }

  async reissueInvoiceNFe(invoiceId) {
    return api.post(`/contigo/invoices/${invoiceId}/reissue-nfe`);
  }

  async cancelInvoice(invoiceId) {
    return api.delete(`/contigo/invoices/${invoiceId}`);
  }

  async getOrdersReport(params) {
    return api.get('/contigo/reports/orders', { params });
  }

  // ATTACHMENTS (Anexos)
  async uploadOrderAttachment(data) {
    return api.post('/contigo/orders/attachments', data);
  }

  async listOrderAttachments(orderId) {
    return api.get(`/contigo/orders/${orderId}/attachments`);
  }

  async deleteOrderAttachment(orderId, attachmentId) {
    return api.delete(`/contigo/orders/${orderId}/attachments/${attachmentId}`);
  }

  // SHIPPING (Expedição)
  async getAvailableInvoicesForShipping() {
    return api.get('/contigo/shipping/available-invoices');
  }

  async createShipment(data) {
    return api.post('/contigo/shipping', data);
  }

  async listShipments(params) {
    return api.get('/contigo/shipping', { params });
  }

  async getShipment(shipmentId) {
    return api.get(`/contigo/shipping/${shipmentId}`);
  }

  async cancelShipment(shipmentId, reason) {
    return api.put(`/contigo/shipping/${shipmentId}/cancel`, { reason });
  }
}

export const contigoService = new ContigoService();
